<template>
    <a-result status="warning" title="There are some problems with your operation.">
        <template #extra>
            <a-button key="console" type="primary">Go Console</a-button>
        </template>
    </a-result>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { Button, Result } from "ant-design-vue";

export default defineComponent({
    components: {
        AResult: Result,
        AButton: Button,
    },
});
</script>
